export namespace SpineConst{
    export const horse = "SpineConst_horse";
    export const PoliceVaz = "police_vaz";
    export const PoliceFord = "police_ford";
    export const Collectables ="collectables";
    export const VFXExplosion = "vfx_explosion";
    export const VFXMoney = "vfx_money";
    export const VFXUMoney = "vfx_unicorn_money";
    export const LowFuel = "LowFuel";
    export const level1City = "level1City";
    export const level2City = "level2City";
}